  // Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license

// tslint:disable:max-line-length

import {
  IIconOptions,
  IIconSubset,
  registerIcons
} from '@uifabric/styling';

export function initializeIcons(
  baseUrl: string = '',
  options?: IIconOptions
): void {
  const subset: IIconSubset = {
    style: {
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
      fontStyle: 'normal',
      fontWeight: 'normal',
      speak: 'none'
    },
    fontFace: {
      fontFamily: `"FabricMDL2Icons-6"`,
      src: `url('${baseUrl}fabric-icons-6-ef6fd590.woff') format('woff')`
    },
    icons: {
      'SwayLogoInverse': '\uED29',
      'OutOfOffice': '\uED34',
      'Trophy': '\uED3F',
      'ReopenPages': '\uED50',
      'EmojiTabSymbols': '\uED58',
      'AADLogo': '\uED68',
      'AccessLogo': '\uED69',
      'AdminALogoInverse32': '\uED6A',
      'AdminCLogoInverse32': '\uED6B',
      'AdminDLogoInverse32': '\uED6C',
      'AdminELogoInverse32': '\uED6D',
      'AdminLLogoInverse32': '\uED6E',
      'AdminMLogoInverse32': '\uED6F',
      'AdminOLogoInverse32': '\uED70',
      'AdminPLogoInverse32': '\uED71',
      'AdminSLogoInverse32': '\uED72',
      'AdminYLogoInverse32': '\uED73',
      'DelveLogoInverse': '\uED76',
      'ExchangeLogoInverse': '\uED78',
      'LyncLogo': '\uED79',
      'OfficeVideoLogoInverse': '\uED7A',
      'SocialListeningLogo': '\uED7C',
      'VisioLogoInverse': '\uED7D',
      'Balloons': '\uED7E',
      'Cat': '\uED7F',
      'MailAlert': '\uED80',
      'MailCheck': '\uED81',
      'MailLowImportance': '\uED82',
      'MailPause': '\uED83',
      'MailRepeat': '\uED84',
      'SecurityGroup': '\uED85',
      'Table': '\uED86',
      'VoicemailForward': '\uED87',
      'VoicemailReply': '\uED88',
      'Waffle': '\uED89',
      'RemoveEvent': '\uED8A',
      'EventInfo': '\uED8B',
      'ForwardEvent': '\uED8C',
      'WipePhone': '\uED8D',
      'AddOnlineMeeting': '\uED8E',
      'JoinOnlineMeeting': '\uED8F',
      'RemoveLink': '\uED90',
      'PeopleBlock': '\uED91',
      'PeopleRepeat': '\uED92',
      'PeopleAlert': '\uED93',
      'PeoplePause': '\uED94',
      'TransferCall': '\uED95',
      'AddPhone': '\uED96',
      'UnknownCall': '\uED97',
      'NoteReply': '\uED98',
      'NoteForward': '\uED99',
      'NotePinned': '\uED9A',
      'RemoveOccurrence': '\uED9B',
      'Timeline': '\uED9C',
      'EditNote': '\uED9D',
      'CircleHalfFull': '\uED9E',
      'Room': '\uED9F',
      'Unsubscribe': '\uEDA0',
      'Subscribe': '\uEDA1',
      'HardDrive': '\uEDA2',
      'RecurringTask': '\uEDB2',
      'TaskManager': '\uEDB7',
      'TaskManagerMirrored': '\uEDB8',
      'Combine': '\uEDBB',
      'Split': '\uEDBC',
      'DoubleChevronUp': '\uEDBD',
      'DoubleChevronLeft': '\uEDBE',
      'DoubleChevronRight': '\uEDBF',
      'TextBox': '\uEDC2',
      'TextField': '\uEDC3',
      'NumberField': '\uEDC4',
      'Dropdown': '\uEDC5',
      'PenWorkspace': '\uEDC6',
      'BookingsLogo': '\uEDC7',
      'ClassNotebookLogoInverse': '\uEDC8',
      'DelveAnalyticsLogo': '\uEDCA',
      'DocsLogoInverse': '\uEDCB',
      'Dynamics365Logo': '\uEDCC',
      'DynamicSMBLogo': '\uEDCD',
      'OfficeAssistantLogo': '\uEDCE',
      'OfficeStoreLogo': '\uEDCF',
      'OneNoteEduLogoInverse': '\uEDD0',
      'PlannerLogo': '\uEDD1',
      'PowerApps': '\uEDD2',
      'Suitcase': '\uEDD3',
      'ProjectLogoInverse': '\uEDD4',
      'CaretLeft8': '\uEDD5',
      'CaretRight8': '\uEDD6',
      'CaretUp8': '\uEDD7',
      'CaretDown8': '\uEDD8',
      'CaretLeftSolid8': '\uEDD9',
      'CaretRightSolid8': '\uEDDA',
      'CaretUpSolid8': '\uEDDB',
      'CaretDownSolid8': '\uEDDC',
      'ClearFormatting': '\uEDDD',
      'Superscript': '\uEDDE',
      'Subscript': '\uEDDF',
      'Strikethrough': '\uEDE0',
      'Export': '\uEDE1',
      'ExportMirrored': '\uEDE2'
    }
  };

  registerIcons(subset, options);
}
